export default __webpack_public_path__ + "static/media/SndLowerYSlideDown.0dee7fca.mp3";